// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eca5f793","885":"07ec6ad7"}[chunkId] + ".chunk.js";
};